// extracted by mini-css-extract-plugin
var _1 = "onlineSchedule-module_btn__x4FWT0";
var _2 = "onlineSchedule-module_btnDefaultColor__TLEd5t";
var _3 = "onlineSchedule-module_disabled__WaT6EJ";
var _4 = "onlineSchedule-module_normal__loHGV0";
export { _1 as "btn", _2 as "btnDefaultColor", _3 as "disabled", _4 as "normal" }
